/** Common tag for all auth operations - enables single dashboard filter: @auth.domain:magicschool.auth */
export const AUTH_DOMAIN = 'magicschool.auth';

/** Extracts error message from unknown error type */
export function getErrorMessage(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}
